import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC, useEffect } from 'react';
import { isWriteMode, ViewMode } from '@/lib/helpers';
import { Box, Stack } from '@mui/material';
import { ConnectorModel } from '@/lib/models/connector/connector.model';
import { DohConnectorModel } from '@/lib/models/connector/doh-connector.model';
import Text from '@/components/text';
import TextInput from '@/components/form/text-input';
import NoneChip from '@/components/chip/none-chip';
import ConnectorStepCard from './connector-step-card';

interface Props {
  connector: DohConnectorModel;
  formHandle: FormHandle<ConnectorModel>;
  mode: ViewMode;
}

// No editable config: write mode renders nothing and only dirties the pre-filled form so it can be submitted.
const DohConnector: FC<Props> = ({ formHandle, mode, connector }) => {
  const inWriteMode = isWriteMode(mode);
  const isNew = !connector.id;
  const { serviceUrl, catalogUrl } = connector.config;

  const { setFieldValue } = formHandle;

  useEffect(() => {
    if (isNew) {
      setFieldValue('config.serviceUrl', '');
    }
  }, [setFieldValue, isNew]);

  if (inWriteMode) {
    return null;
  }

  return (
    <Box mt={2}>
      <ConnectorStepCard title="Deployment">
        <Stack gap={2}>
          <Text bold>DoH URL</Text>
          {serviceUrl ? (
            <TextInput
              name="serviceUrl"
              disabled
              copyClip
              value={serviceUrl}
              fullWidth
              size="x-small"
            />
          ) : (
            <NoneChip />
          )}

          <Text bold>Catalog URL</Text>
          {catalogUrl ? (
            <TextInput
              name="catalogUrl"
              disabled
              copyClip
              value={catalogUrl}
              fullWidth
              size="x-small"
            />
          ) : (
            <NoneChip />
          )}
        </Stack>
      </ConnectorStepCard>
    </Box>
  );
};

export default DohConnector;
